import { Office } from "@/models/office";
import { SearchAccidentReportsCondition } from "@/models/accidentReport";

export const AccidentReportsConstants = {
  AccidentReports: "事故報告一覧",
  CompanyOffice: "会社/営業所",
  Company: "会社",
  Office: "営業所",
  AccidentNo: "事故番号",
  RadioNumber: "無線番号",
  Classification: "区分",
  Type: "事故種別",
  HappenedAt: "発生日時",
  ReportedAt: "報告日時",
  OpenAccidentForm: "事故報告フォームを開く",
} as const;

export type SavedState = {
  officesSelected: Office[];
  page: number;
  searchCondition: SearchAccidentReportsCondition;
};

export const PAGE_SIZE = 30;

export const CLASSIFICATION_LABELS: Record<string, string> = {
  SERIOUS: "区分1",
  OTHERS: "区分2",
};

export const TYPE_LABELS: Record<string, string> = {
  PERSONAL_INJURY: "車両の人損事故",
  SNS_OUTRAGE: "SNS炎上・情報漏洩など",
  PROPERTY_DAMAGE: "車両の物損事故",
  SELF_INFLICTED: "車両の自損事故",
  CHARGING_INFRA_DAMAGE: "充電設備等の損壊・事故",
};

export const DEFAULT_SEARCH_CONDITION: SearchAccidentReportsCondition = {
  officeIds: [],
};

export const getClassificationLabel = (classification: string): string => {
  return CLASSIFICATION_LABELS[classification] ?? classification;
};

export const getTypeLabel = (type: string): string => {
  return TYPE_LABELS[type] ?? type;
};
